exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".review-page {\n  padding: 50px;\n  margin-right: 80px;\n  font-weight: 400;\n  color: black; }\n", ""]);

